import type { GetDepartmentTypeByIdResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetDepartmentTypeByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetDepartmentTypeByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetDepartmentTypeByIdArgs = {
  id?: string;
};

export const useGetDepartmentTypeById = createQueryHook<
  UseGetDepartmentTypeByIdArgs,
  GetDepartmentTypeByIdResponseRow[],
  GetDepartmentTypeByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.department.departmentTypeById.queryOptions({ id: id! }),
  mapTrpcDataToGraphQL: (data) => ({ department_type: data }),
  graphqlDocument: GetDepartmentTypeByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
